import { ca } from '@cian/analytics';

export const trackRoadsPopupOpened = () =>
  ca('event', {
    action: 'highway_open',
    category: 'FilterPopup',
    label: '',
    name: 'oldevent',
  });

export const trackRoadsPopupClosed = () =>
  ca('event', {
    action: 'highway_close',
    category: 'FilterPopup',
    label: '',
    name: 'oldevent',
  });

export const trackRoadSearchKeypress = () =>
  ca('event', {
    action: 'highway_suggest',
    category: 'FilterPopup',
    label: 'Keypress',
    name: 'oldevent',
  });

export const trackSuggestChosen = () =>
  ca('event', {
    action: 'highway_suggest',
    category: 'FilterPopup',
    label: 'Choose',
    name: 'oldevent',
  });

export const trackRoadsSearchEmpty = () =>
  ca('event', {
    action: 'highway_suggest',
    category: 'FilterPopup',
    label: 'Nothingfound',
    name: 'oldevent',
  });

export const trackRoadSelected = (label: string = '') =>
  ca('event', {
    action: 'highway_select_full',
    category: 'FilterPopup',
    label,
    name: 'oldevent',
  });

export const trackSubroadSelected = (label: string = '') =>
  ca('event', {
    action: 'highway_select_part',
    category: 'FilterPopup',
    label,
    name: 'oldevent',
  });

export const trackRoadDistanceChanged = () =>
  ca('event', {
    action: 'highway_select',
    category: 'FilterPopup',
    label: 'Distance',
    name: 'oldevent',
  });

export const trackRoadHovered = (label = '', isPart = false) =>
  ca('event', {
    action: isPart ? 'highway_hover_part' : 'highway_hover_full',
    category: 'FilterPopup',
    label,
    name: 'newevent',
  });

export const trackDisabledSubmitClicked = () =>
  ca('event', {
    action: 'highway_trytosave',
    category: 'FilterPopup',
    label: 'Button_disabled',
    name: 'oldevent',
  });

export const trackSavedRoadDeleted = () =>
  ca('event', {
    action: 'highway_delete',
    category: 'FilterPopup',
    label: '',
    name: 'oldevent',
  });
